<app-overlay-modal
  [mobile]="mobile()"
  [title]="title()"
  (backdrop)="backdropClick.emit()"
  (close)="modalClose.emit()"
>
  <div modal-body class="list" [class.double-column]="!mobile()">
    @for (opt of options(); track opt.code) {
      <div
        class="list-item"
        (click)="onSelect(opt.code, $event)"
        tabindex="0"
        (keydown.enter)="onSelect(opt.code, $event)"
      >
        <div class="item-content">
          @if (opt.icon) {
            <img [src]="opt.icon" class="flag-icon" alt="" />
          }
          <span class="name">{{ getLabel(opt.code) | translate }}</span>
        </div>
        @if (isChosen(opt.code)) {
          <div class="check-icon-wrapper">
            <mat-icon class="check-icon">check</mat-icon>
          </div>
        }
      </div>
    }
  </div>

  <div modal-actions class="action-buttons">
    <button class="cancel-button" (click)="cancelClick.emit()">
      {{ "common.cancel" | translate }}
    </button>
    <button class="save-button" (click)="saveClick.emit()">
      {{ "common.save" | translate }}
    </button>
  </div>
</app-overlay-modal>
